<script setup>
import {ref} from "vue";
import {router} from '@inertiajs/vue3'


const props = defineProps({
    'male_lose_weight_starter_product': String,
    'male_lose_weight_advanced_product': String,

    'male_gain_muscle_starter_product': String,
    'male_gain_muscle_advanced_product': String,

    'male_performance_starter_product': String,
    'male_performance_advanced_product': String,

    'female_lose_weight_starter_product': String,
    'female_lose_weight_advanced_product': String,

    'female_gain_muscle_starter_product': String,
    'female_gain_muscle_advanced_product': String,

    'female_performance_starter_product': String,
    'female_performance_advanced_product': String,
});

const steps = [
    {
        label: 'gender',
        question: 'Ik ben een:',
        answers: [
            {'label': 'Man', goTo: 'goal', state: 'male'},
            {'label': 'Vrouw', goTo: 'goal', state: 'female'},
        ],
    },
    {
        label: 'goal',
        question: 'Het doel wat ik wil bereiken is:',
        answers: [
            {'label': 'Gewicht verliezen', goTo: 'level', state: 'lose_weight'},
            {'label': 'Spier-opbouw', goTo: 'level', state: 'gain_muscle'},
            {'label': 'Performance / Health', goTo: 'level', state: 'performance'},
        ],
    },
    {
        label: 'level',
        question: 'Mijn niveau is:',
        answers: [
            {'label': 'Beginner', goTo: 'end', state: 'starter'},
            {'label': 'Gevorderd', goTo: 'end', state: 'advanced'},

        ],
    },
]
const currentState = ref('');

const currentStep = ref(0);

function goToStep(answer) {
    currentState.value = currentState.value ? currentState.value + '_' + answer.state : answer.state;
    if (answer.goTo === 'end') {
        router.visit(props[currentState.value + '_product']);
    } else {
        currentStep.value = steps.findIndex(step => step.label === answer.goTo);
    }
}
</script>

<template>
    <div class="container my-8 md:my-16">
        <h2 class=" mb-4 text-center text-lg font-extrabold uppercase lg:mb-8 lg:text-3xl">
            Welk pakket past bij mij?
        </h2>
        <p class="mb-8 text-center lg:mb-8">
            {{ steps[currentStep].question }}
        </p>
        <div class="flex-center">
            <div
                class="flex-center md:text-md relative  flex-col gap-4 text-center text-sm font-extrabold uppercase md:flex-row lg:text-2xl"
            >
                <button
                    v-for="(answer) in steps[currentStep].answers"
                    :key="answer.label"
                    class="aspect-[1/1] w-40 rounded border-primary bg-primary p-4 uppercase text-white ring-primary transition duration-300 hover:bg-primary-800 hover:ring-primary-800 focus:ring-primary-600 lg:w-60 "
                    @click="goToStep(answer)"
                >
                    {{ answer.label }}
                </button>


                <div class="absolute -inset-x-4 inset-y-8 z-[-1] rounded bg-grey" />
            </div>
        </div>
    </div>
</template>
